{
  "common": {
    "next": "التالي",
    "back": "السابق",
    "loading": "جارٍ التحميل …",
    "submit": "إرسال مُلزِم",
    "submitting": "جارٍ الإرسال …",
    "select": "— يُرجى الاختيار —",
    "yes": "نعم",
    "dash": "—"
  },
  "nav": {
    "title": "تسجيل الموكّلين",
    "subtitle": "GQL Gussone Quecke Legal Partnerschaft von Rechtsanwälten mbB",
    "impressum": "بيانات النشر القانونية",
    "datenschutz": "سياسة الخصوصية"
  },
  "lang": {
    "label": "اللغة",
    "de": "Deutsch",
    "en": "English",
    "ar": "العربية",
    "fr": "Français"
  },
  "onboarding": {
    "title": "تسجيل الموكّلين",
    "subtitle": "يُرجى وصف وقائع قضيتكم بإيجاز. يمكنكم التوقّف في أي وقت — إذ تُحفَظ مدخلاتكم تلقائياً.",
    "submittedTitle": "شكراً لكم — لقد استلمنا طلبكم.",
    "submittedBody": "تم إرسال مستنداتكم. سنراجع الوقائع ونتواصل معكم خلال أيام عمل قليلة.",
    "submittedDashboardPrefix": "يمكنكم الاطّلاع على الحالة في أي وقت من خلال ",
    "submittedDashboardLink": "لوحة التحكم",
    "submittedDashboardSuffix": " أو تحديد موعد عبر الإنترنت من هناك.",
    "steps": {
      "sachverhalt": "الوقائع",
      "fragebogen": "الاستبيان",
      "gegenseite": "الطرف المقابل",
      "vollmacht": "التوكيل",
      "uploads": "المستندات",
      "review": "المراجعة والإرسال"
    },
    "sachverhalt": {
      "rechtsgebietLabel": "مجال القانون",
      "beschreibungLabel": "وصف موجز لطلبكم",
      "beschreibungPlaceholder": "ماذا حدث؟ من الأطراف المعنيّة؟ ما الخطوات التي اتخذتموها حتى الآن؟",
      "counter": "{{chars}} / 20000 حرف",
      "minHint": "ثلاثة أحرف على الأقل للمتابعة"
    },
    "gegenseite": {
      "hint": "إذا لم يكن الطرف المقابل معروفاً حالياً، يُرجى إدخال \"—\".",
      "nameLabel": "اسم / شركة الطرف المقابل",
      "anschriftLabel": "العنوان (إن كان معروفاً)",
      "vertretenLabel": "التمثيل القانوني للطرف المقابل (إن كان معروفاً)"
    },
    "vollmacht": {
      "p1": "في المراحل اللاحقة سنحتاج إلى توكيل محاماة خطّي. وسيُرسَل إليكم للتوقيع بعد الاطّلاع على الوقائع (إمّا إلكترونياً أو عبر خطاب).",
      "p2": "نرجو منكم منذ الآن إبداء موافقتكم المبدئية على أن يقوم مكتب GQL Gussone Quecke Legal بفحص القضية وقبولكم كموكّلين عند الاقتضاء.",
      "checkbox": "أكلّف مكتب GQL Gussone Quecke Legal بفحص الوقائع المعروضة هنا وإعداد توكيل محاماة."
    },
    "uploads": {
      "hint": "يُرجى رفع جميع المستندات ذات الصلة — لا سيّما وثيقة الهوية (تحديد الهوية وفقاً لقانون مكافحة غسل الأموال الألماني (GwG))، والتوكيل (إن سبق منحه)، والمراسلات مع الطرف المقابل وسائر أدلة الإثبات."
    },
    "review": {
      "title": "الملخّص",
      "rechtsgebiet": "مجال القانون",
      "sachverhalt": "الوقائع",
      "gegenseite": "الطرف المقابل",
      "vertretenDurch": "يمثّله: {{name}}",
      "vollmachtErklaerung": "إقرار التوكيل",
      "fragebogen": "الاستبيان",
      "unterlagen": "المستندات ({{count}})",
      "notReady": "يُرجى أولاً استكمال الوقائع والطرف المقابل وإقرار التوكيل."
    },
    "errors": {
      "alreadySubmitted": "لقد قمتم بالإرسال بالفعل.",
      "submitFailed": "فشل الإرسال — يُرجى المحاولة لاحقاً.",
      "unexpected": "حدث خطأ غير متوقّع."
    }
  },
  "rechtsgebiete": {
    "arbeitsrecht": "قانون العمل",
    "mietrecht": "قانون الإيجار",
    "familienrecht": "قانون الأسرة",
    "verkehrsrecht": "قانون المرور",
    "strafrecht": "القانون الجنائي",
    "kartellrecht": "قانون مكافحة الاحتكار",
    "vergaberecht": "قانون المناقصات العامة",
    "verwaltungsrecht": "القانون الإداري",
    "sonstiges": "أخرى"
  },
  "upload": {
    "kategorieLabel": "فئة الملف",
    "kategorien": {
      "ausweis": "بطاقة الهوية / إثبات الهوية",
      "vollmacht": "التوكيل / التكليف",
      "korrespondenz": "المراسلات (خطابات، رسائل بريد إلكتروني)",
      "beweis": "أدلة الإثبات / المستندات",
      "sonstiges": "أخرى"
    },
    "dropHint": "PDF، JPG، PNG، HEIC، ZIP · بحد أقصى 10 MB لكل ملف",
    "tooBig": "حجم الملف \"{{name}}\" أكبر من 10 MB.",
    "failed": "فشل الرفع — يُرجى المحاولة مرة أخرى.",
    "remove": "إزالة",
    "removeAria": "إزالة {{name}}"
  },
  "questionnaire": {
    "title": "أسئلة حول قضيتكم",
    "intro": "يُرجى الإجابة عن الأسئلة التالية بأكبر قدر ممكن من الاكتمال. تساعدنا بياناتكم على تقييم قضيتكم تقييماً صحيحاً.",
    "optionalHint": "(اختياري)",
    "requiredHint": "حقل إلزامي",
    "selectPlaceholder": "— يُرجى الاختيار —",
    "loading": "جارٍ تحميل الاستبيان …",
    "answeredCount": "تمت الإجابة عن {{answered}} من {{total}}"
  },
  "legalNotice": {
    "deAuthoritative": "هذا النص القانوني مُلزِم في صيغته الألمانية. وتُقدَّم الترجمات لغرض تيسير الفهم فقط."
  },
  "register": {
    "title": "التسجيل",
    "subtitle": "لكي نتمكّن من تسجيل استفسارك بصورة منظَّمة، يُرجى التسجيل ببياناتك الأساسية. وستتلقّى بعد ذلك رسالة تأكيد بالبريد الإلكتروني.",
    "vorname": "الاسم الأول",
    "nachname": "اسم العائلة",
    "geburtsdatum": "تاريخ الميلاد",
    "email": "عنوان البريد الإلكتروني",
    "required": "حقل إلزامي",
    "einwilligungRequired": "الموافقة مطلوبة",
    "einwilligung": "أوافق على معالجة بياناتي لغرض الشروع في توكيل. وتُعامَل البيانات بسرّية وتخضع لواجب السرّية المهنية للمحاماة (§ 43a Abs. 2 BRAO).",
    "captchaPlease": "يُرجى تأكيد CAPTCHA.",
    "submit": "إرسال التسجيل",
    "submitting": "يُرجى الانتظار …",
    "haveAccount": "هل أنت مسجَّل بالفعل؟",
    "login": "تسجيل الدخول",
    "errCaptcha": "رفضت الحماية من الروبوتات هذه المحاولة. يُرجى حلّ CAPTCHA من جديد.",
    "errValidation": "يُرجى التحقّق من حقول الإدخال.",
    "errRateLimit": "عدد كبير جدًّا من عمليات التسجيل من هذا الاتصال. يُرجى المحاولة لاحقًا.",
    "errGeneric": "حدث خطأ. يُرجى المحاولة لاحقًا.",
    "errUnexpected": "حدث خطأ غير متوقَّع."
  },
  "login": {
    "title": "تسجيل الدخول",
    "subtitle": "ستتلقّى رابط دخول لمرّة واحدة عبر البريد الإلكتروني. ولا حاجة إلى إدخال كلمة مرور.",
    "email": "عنوان البريد الإلكتروني",
    "required": "حقل إلزامي",
    "captchaPlease": "يُرجى تأكيد CAPTCHA.",
    "submit": "طلب رابط الدخول",
    "submitting": "يُرجى الانتظار …",
    "consumingTitle": "جارٍ تسجيل الدخول …",
    "wait": "يُرجى الانتظار لحظة.",
    "sentTitle": "تمّ إرسال رابط الدخول",
    "sentBody": "إذا كان عنوان البريد الإلكتروني مسجَّلًا، فقد أرسلنا رابط دخول. والرابط صالح لمدة 15 دقيقة.",
    "errorTitle": "تعذَّر تسجيل الدخول",
    "errInvalid": "رابط الدخول غير صالح أو انتهت صلاحيته.",
    "errGeneric": "فشل تسجيل الدخول.",
    "errRequest": "فشل الطلب.",
    "errCaptcha": "رفضت الحماية من الروبوتات هذه المحاولة.",
    "newLink": "طلب رابط جديد",
    "register": "التسجيل",
    "noAccount": "ألم تسجِّل بعد؟",
    "registerNow": "سجِّل الآن"
  },
  "verify": {
    "checkingTitle": "جارٍ التحقّق من التأكيد …",
    "wait": "يُرجى الانتظار لحظة.",
    "successTitle": "تمّ تأكيد البريد الإلكتروني",
    "successBody": "شكرًا لك — تمّ تفعيل وصولك. وسيُعاد توجيهك إلى Onboarding …",
    "errorTitle": "تعذَّر التأكيد",
    "errInvalid": "رابط التأكيد غير صالح أو انتهت صلاحيته بالفعل.",
    "errGeneric": "فشل التأكيد.",
    "noToken": "لا يوجد رمز في الرابط.",
    "registerNew": "التسجيل من جديد",
    "requestLogin": "طلب رابط الدخول"
  },
  "verifySent": {
    "title": "تمّ إرسال رسالة التأكيد",
    "bodyWithEmail": "لقد أرسلنا رابط تأكيد إلى {{email}}. يُرجى النقر عليه لفتح منطقة Onboarding.",
    "bodyNoEmail": "لقد أرسلنا إليك رابط تأكيد عبر البريد الإلكتروني. يُرجى النقر عليه لفتح منطقة Onboarding.",
    "validity": "الرابط صالح لمدة 24 ساعة. ويُرجى التحقّق من مجلد البريد العشوائي عند الاقتضاء.",
    "notArrivedPrefix": "إذا لم تصل الرسالة، يمكنك ",
    "notArrivedLink": "التسجيل من جديد",
    "notArrivedSuffix": "."
  },
  "invite": {
    "checkingTitle": "جارٍ التحقّق من الدعوة …",
    "wait": "يُرجى الانتظار لحظة.",
    "successTitle": "مرحبًا بك",
    "successBody": "تمّ تفعيل وصولك. وسيُعاد توجيهك إلى Onboarding …",
    "errorTitle": "تعذَّرت الدعوة",
    "errorInvalid": "رابط الدعوة غير صالح أو انتهت صلاحيته.",
    "errorGeneric": "فشل الاستخدام.",
    "loginLink": "طلب رابط الدخول بدلًا من ذلك"
  },
  "dashboard": {
    "loading": "جارٍ التحميل …",
    "notLoggedIn": "غير مسجَّل الدخول",
    "welcome": "مرحبًا، {{name}}.",
    "subtitle": "يمكنك هنا تعديل بيانات Onboarding الخاصة بك أو تحديد موعد.",
    "subtitleWithTax": "يمكنك هنا تعديل بيانات Onboarding الخاصة بك، واستكمال البيانات الضريبية لعامي 2021 و2022، أو تحديد موعد.",
    "name": "الاسم",
    "email": "البريد الإلكتروني",
    "verifiedSince": "مُوثَّق منذ",
    "logout": "تسجيل الخروج",
    "requestH": "استفسار الموكِّل الخاص بك",
    "submitted": "تمّ إرسال استفسارك. ونحن بصدد فحص الوقائع وسنتواصل معك في غضون أيام عمل قليلة.",
    "draftHint": "لديك مسوّدة Onboarding بدأتَها. ويمكنك متابعتها من هناك.",
    "continue": "متابعة Onboarding",
    "startHint": "صِف لنا وقائع قضيتك، وارفع المستندات ذات الصلة — وسنفحص الأمر ونتواصل معك.",
    "start": "بدء Onboarding",
    "taxH": "النموذج الضريبي لعائلة حيدر لعامي 2021 و2022",
    "taxHint": "يرجى استكمال البيانات المطلوبة لإقرارات تحديد الدخل وإقرارات ضريبة الدخل الشخصية لعامي 2021 و2022، ورفع المستندات المؤيدة. تُحفظ إدخالاتك تلقائيًا.",
    "taxStart": "فتح النموذج الضريبي",
    "taxContinue": "متابعة النموذج الضريبي",
    "taxSubmitted": "تم إرسال النموذج الضريبي للمراجعة. لا يتم إرسال أي بيانات إلى ELSTER أو مكتب الضرائب من خلال هذه البوابة.",
    "nachreichungH": "تقديم مستندات إضافية",
    "nachreichungHint": "يمكنك هنا رفع مستندات إضافية (إشعارات الفسخ، اتفاقيات الإنهاء، عقد العمل، كشوف الرواتب، المراسلات وغيرها). وتُنقَل الملفات مباشرةً إلى ملف قضيتك، شريطة أن يكون قد أُنشئ بالفعل.",
    "terminH": "تحديد موعد عبر الإنترنت مدته 30 دقيقة",
    "terminHint": "يمكنك حجز موعد مدته 30 دقيقة مباشرةً مع المحامي Moritz Quecke. ويُعقَد الموعد بصيغة اجتماع Microsoft Teams؛ وستتلقّى الرابط عبر البريد الإلكتروني بعد الحجز.",
    "bookButton": "حجز موعد (يفتح نافذة جديدة)",
    "bookInline": "أو احجز مباشرةً هنا في النافذة",
    "bookFrameTitle": "حجز موعد",
    "bookSoon": "يجري حاليًّا إعداد صفحة الحجز. وبمجرّد توفّرها، سيظهر هنا زرّ للحجز."
  },
  "notFound": {
    "title": "الصفحة غير موجودة",
    "subtitle": "الصفحة المطلوبة غير موجودة.",
    "toRegister": "إلى التسجيل"
  },
  "intake": {
    "title": "أسئلة حول قضيتكم",
    "subtitle": "يُرجى الإجابة عن الأسئلة التالية، ورفع المستندات المطلوبة، ومنح التوكيل. تُحفظ مدخلاتكم تلقائياً.",
    "notReady": "يُرجى الإجابة عن جميع الأسئلة الإلزامية ومنح التوكيل.",
    "noQuestionnaireTitle": "لا يوجد استبيان مُخصَّص",
    "noQuestionnaire": "لا يوجد استبيان خاص بالقضية مخصَّص لهذا الوصول. يُرجى استخدام التسجيل العام."
  }
}
